var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var AccountBusiness = function (storeContainer) {
    var store = storeContainer.store;
    var accountStore = store.accountStore, userProfileStore = store.userProfileStore, commonStore = store.commonStore;
    var propsConnect = {
        clientInfo: accountStore.clientInfo,
        userLoginData: accountStore.userLoginData,
        residentInfo: accountStore.residentInfo,
    };
    var dispatchConnect = {
        getClientInfo: function () { return accountStore.getClientInfo(); },
        userLogin: function (userInfo) { return accountStore.userLogin(userInfo); },
        forGotPasswordSendEmail: function (email) { return accountStore.forGotPasswordSendEmail(email); },
        forGotPasswordSendVerificationCode: function (phoneNumber) { return accountStore.forGotPasswordSendVerificationCode(phoneNumber); },
        sendOneTimeCode: function (query) { return accountStore.sendOneTimeCode(query); },
        verifyOneTimeCode: function (query) { return accountStore.verifyOneTimeCode(query); },
        register: function (userIdentity) { return accountStore.register(userIdentity); },
        checkEmail: function (email) { return accountStore.checkEmail(email); },
        getResidentInfo: function (residentId, token, clientId) {
            return accountStore.getResidentInfo(residentId, token, clientId);
        },
        getSignUpByEmail: function (residentId, token, clientId) {
            return accountStore.getSignUpByEmail(residentId, token, clientId);
        },
        sendEmailByToken: function (token) { return accountStore.sendEmailByToken(token); },
        getCheckCreateUserNameResult: function (userName) { return accountStore.getCheckCreateUserNameResult(userName); },
        resetPassword: function (resetPasswordModel) { return accountStore.resetPassword(resetPasswordModel); },
        getResidentDetailByPhone: function (phoneNumber) { return accountStore.getResidentDetailByPhone(phoneNumber); },
        getResidentContactListByLocation: function (request) { return accountStore.getResidentContactListByLocation(request); },
        getResidentAddress: function (address) { return accountStore.getResidentAddress(address); },
        getResidentCity: function (city) { return accountStore.getResidentCity(city); },
        getResidentState: function (city) { return accountStore.getResidentState(city); },
        getCallCenterPhone: function () { return accountStore.getCallCenterPhone(); },
        verifyOtp: function (request) { return accountStore.verifyOtp(request); },
        sendOtpToPhone: function (request) { return accountStore.sendOTPToPhone(request); },
        signInByOtp: function (accessToken, eventId) { return accountStore.signInByOtp(accessToken, eventId); },
        logout: function () { return accountStore.logout(); },
        getDashboardResidentInfo: function (residentId) { return userProfileStore.getResidentInfo(residentId); },
        getConfirmedPhone: function () { return accountStore.getConfirmedPhone(); },
        verifyCode: function (phoneNumber, code) { return accountStore.verifyCode(phoneNumber, code); },
        checkEmailToken: function (userName, token) { return accountStore.checkEmailToken(userName, token); },
        createUserByEmail: function (email, token, residentId) { return accountStore.createUserByEmail(email, token, residentId); },
    };
    return __assign(__assign({}, propsConnect), dispatchConnect);
};
